export default __webpack_public_path__ + "static/media/ovidiu_nistor.391259e1.png";